import { render, staticRenderFns } from "./AccessManagementReportPage.vue?vue&type=template&id=ccf32228&scoped=true&lang=pug"
import script from "./AccessManagementReportPage.vue?vue&type=script&lang=js"
export * from "./AccessManagementReportPage.vue?vue&type=script&lang=js"
import style0 from "./AccessManagementReportPage.vue?vue&type=style&index=0&id=ccf32228&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf32228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccf32228')) {
      api.createRecord('ccf32228', component.options)
    } else {
      api.reload('ccf32228', component.options)
    }
    module.hot.accept("./AccessManagementReportPage.vue?vue&type=template&id=ccf32228&scoped=true&lang=pug", function () {
      api.rerender('ccf32228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/monitoring/AccessManagementReportPage.vue"
export default component.exports